import { VendorRepository } from "../../repositories/VendorRepository";
import { VendorSearchResultEntity } from "../../entities/VendorEntity";

/**
 * Search Vendors Use Case
 * Searches for vendors with optional filters and pagination
 */
export class SearchVendorsUseCase {
  constructor(private repository: VendorRepository) {}

  async execute(params: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  } = {}): Promise<VendorSearchResultEntity> {
    // Validate pagination parameters
    if (params.page !== undefined && params.page < 1) {
      throw new Error("Page number must be at least 1");
    }

    if (params.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.searchVendors(params);
  }
}

